// autogenerated by channel_search/generate.py -- do not edit
import { ClientStatus } from "@skydio/pbtypes/pbtypes/vehicle/infrastructure/flight_deck/status_pb";
export { ClientStatus };

export const CLIENT_STATUS_PB = {
  channel: "CLIENT_STATUS_PB",
  type: ClientStatus.deserializeBinary
};
